import { useState } from "react";
import styles from "./banner.module.scss";
import { compressImage } from "@utils/compressImage";
export interface IBannerProps {
	altText: string;
	srcSet?: string;
	coverImage: string;
	children?: React.ReactNode;
}

const Banner = ({ altText, coverImage, children }: IBannerProps): JSX.Element => {
	const [imgError, setImgError] = useState(false);

	const bannerImage = () => {
		const fallbackUrl = "https://amigoedu.com.br/blogdoamigo/wp-content/uploads/2020/11/faculdade-exterior_.jpg";

		if (imgError) return <img src={coverImage} alt={altText} />;

		return (
			<picture>
				<source srcSet={compressImage({ url: coverImage || fallbackUrl, width: 1920, format: "webp" })} type="image/webp" />
				<source srcSet={compressImage({ url: coverImage || fallbackUrl, width: 1920 })} type="image/jpeg" />
				<img src={compressImage({ url: coverImage || fallbackUrl, width: 1920 })} alt={altText} onError={() => setImgError(true)} />
			</picture>
		);
	};

	return (
		<section className={styles.banner}>
			<figure>
				<picture>{bannerImage()}</picture>
			</figure>

			<div className={styles.waves} />

			<div className={styles.children}>{children}</div>
		</section>
	);
};

export default Banner;
